<template>
    <aside class="left-menu" 
        :class="{
            'left-menu-collapsed': isCollapsed,
        }">
            <div class="left-menu-brand" @click="goto('/dashboard')">
                <img class="left-menu-logo" src="../../assets/logo-only-icon.png" alt="logo">
                <img class="left-menu-logo-and-text" src="../../assets/logo-and-text.png" alt="logo">
            </div>

            <ul class="left-menu-items-container">
                <li class="left-menu-item"
                    v-for="(item, index) in menuItems" :key="index"
                    :class="{active: item.active}"
                    v-show="item.isVisible()">
                    <router-link class="left-menu-item-container" :to="item.path" v-if="!item.external">
                        <fa :icon="item.icon" class="left-menu-icon" />
                        <span class="left-menu-item-description">{{item.description}}</span>
                    </router-link>

                    <a class="left-menu-item-container" :href="item.path" target="_blank" v-if="!!item.external">
                        <fa :icon="item.icon" class="left-menu-icon" />
                        <span class="left-menu-item-description">{{item.description}}</span>
                    </a>
                </li>

                <li class="left-menu-item left-menu-item-collapse-action"
                    @click="toggleCollapse()" >
                    <span class="left-menu-item-container" v-show="isCollapsed">
                        <fa icon="chevron-circle-right" 
                            class="left-menu-icon" />                        
                    </span>

                    <span class="left-menu-item-container" v-show="!isCollapsed">
                        <fa icon="chevron-circle-left" 
                            class="left-menu-icon" />
                        <span class="left-menu-item-description">Esconder</span>
                    </span>
                </li>
            </ul>
    </aside>    
</template>

<script>
import { mapState } from 'vuex';
export default {
    name: 'LeftMenuCmp',
    data() {
        return {
            isCollapsed: false,
            menuItems: [
                {
                    basePath: '/principal',
                    path: '/principal',
                    description: 'Principal',
                    icon: 'home',
                    active: false,
                    isVisible: () => this.userAuthenticated.hasRoleAdmin(),
                },
                {
                    basePath: '/faturamento',
                    path: '/faturamento',
                    description: 'Faturamento',
                    icon: 'dollar-sign',
                    active: false,
                    isVisible: () => this.userAuthenticated.hasRoleAdmin(),
                },
                {
                    basePath: '/clientes',
                    path: '/clientes',
                    description: 'Clientes',
                    icon: 'users',
                    active: false,
                    isVisible: () => this.userAuthenticated.hasRoleAdmin() || this.userAuthenticated.hasRoleBiller() || this.userAuthenticated.hasRoleSellerOperator() || this.userAuthenticated.hasRoleOperator(),
                },
                {
                    basePath: '/vendedores',
                    path: '/vendedores',
                    description: 'Vendedores',
                    icon: 'user-tie',
                    active: false,
                    isVisible: () => this.userAuthenticated.hasRoleAdmin() || this.userAuthenticated.hasRoleBiller() || this.userAuthenticated.hasRoleSellerOperator() || this.userAuthenticated.hasRoleOperator(),
                },
                {
                    basePath: '/crm',
                    path: '/crm',
                    description: 'CRM',
                    icon: 'tasks',
                    active: false,
                    isVisible: () => this.userAuthenticated.hasRoleAdmin() || this.userAuthenticated.hasRoleSupport(),
                },
            ],
        }
    },
    mounted() {
        this._activateRoute(this.$route.path)
    },
    methods: {
        goto(path) {
            if (this.$route.path !== path) {
                this.$router.push(path);
            }
        },
        toggleCollapse() {
            this.isCollapsed = !this.isCollapsed
            this.$emit('oncollapsed', {isCollapsed: this.isCollapsed})
        },
        _activateRoute(path) {
            for (const item of this.menuItems) {
                item.active = false;
            }

            for (const item of this.menuItems) {
                const samePath = path === item.path
                const sameBasePath = path.startsWith(item.basePath)

                if (samePath || sameBasePath) {
                    item.active = true;
                    break;
                }
            }           
        },
    },
    watch: {
        $route(to, from) {
            this._activateRoute(to.path)
        },
    },
    computed: {
        ...mapState({
            userAuthenticated: state => state.userAuthenticated,
        })
    },
}
</script>

<style lang="scss" scoped>
@import '../../utils/styles/constants.scss';

.left-menu {
    position: fixed;
    background-color: #fff;
    left: 0;
    top: 0;
    width: 200px;
    height: 100%;
    margin-right: 15px;
    z-index: 2;

    &.left-menu-collapsed {
        width: 68px;

        .left-menu-brand {
            padding-left: 0;

            .left-menu-logo {
                display: block;
            }

            .left-menu-logo-and-text {
                display: none;
            }
        }

        ul.left-menu-items-container {
        
           li.left-menu-item {
                .left-menu-item-description {
                    display: none;
                }
           }
        }
    }

    .left-menu-brand {
        position: relative;
        cursor: pointer;
        padding: 9px 6px 9px 10px;
        color: #9f0d8b;
        font-weight: 700;

        .left-menu-version-info {
            position: absolute;
            color: orange;
            bottom: -2px;
            right: 27px;
            font-size: .4em;
            font-weight: 600;
        }

        .left-menu-logo,
        .left-menu-logo-and-text {
            margin-top: 0;
            margin-left: 5px;
            margin-right: 18px;
        }

        .left-menu-logo {
            display: none;
        }

        .left-menu-logo-and-text {
            display: block;
        }
    }

    ul.left-menu-items-container {
        list-style: none;
        padding-left: 0;        

        li.left-menu-item {
            &>a,
            &>span {
                display: block;
                padding: 6px 10px 6px 19px;   

                @media(min-height: 650px) {
                    padding-top: 10px;
                    padding-bottom: 10px;
                }
            }

            &:first-of-type {
                margin-top: -2px;
            }

            &.left-menu-item-collapse-action {
                position: absolute;
                bottom: 0;
                width: 100%;
            }

            &:hover {
                cursor: pointer;
                background-color: $bg-default-color;
            }

            &.active {
                background-color: $bg-default-color;
            }

            .left-menu-icon {
                width: 30px;
                text-align: center;
                margin-right: 20px;
                font-size: 1.1em;
            }

            .left-menu-item-container {
                color: #444;

                &:hover {
                    text-decoration: none;
                }
            }
        }
    }
}
</style>
